import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import { fetchMe, logout as apiLogout, loginUrl } from "./api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        const me = await fetchMe();
        setUser(me);
        setLoading(false);
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const login = useCallback(() => {
        window.location.href = loginUrl;
    }, []);

    const logout = useCallback(async () => {
        await apiLogout();
        setUser(null);
        window.location.href = "/admin/login";
    }, []);

    const value = useMemo(
        () => ({ user, loading, login, logout, refresh }),
        [user, loading, login, logout, refresh]
    );

    return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => {
    const ctx = useContext(AuthCtx);
    if (!ctx) throw new Error("useAuth must be inside AuthProvider");
    return ctx;
};
